import { useQuery } from "@apollo/client";
import type {
  DataSourceDefinitionsResponse,
  UseDataSourceDefinitionOptions,
  UseThreatIntelligenceDefinitionResult,
} from "./types";
import { GET_THREAT_INTELLIGENCE_DEFINITIONS } from "./APIs/ThreatIntelligenceApi";

const useThreatIntelligenceDefinition = (
  options: UseDataSourceDefinitionOptions = {}
): UseThreatIntelligenceDefinitionResult => {
  const {
    withLastReceived = false,
    withTags = false,
    filters = {},
    fetchPolicy = "cache-first",
  } = options;

  const {
    data: threatIntelligenceDefinitions,
    error: threatIntelligenceDefinitionsError,
    loading: threatIntelligenceDefinitionsLoading,
  } = useQuery<DataSourceDefinitionsResponse>(
    GET_THREAT_INTELLIGENCE_DEFINITIONS,
    {
      fetchPolicy,
      variables: {
        with_last_received: withLastReceived,
        with_tags: withTags,
        filters,
      },
    }
  );

  return {
    threatIntelligenceDefinitions,
    threatIntelligenceDefinitionsError,
    threatIntelligenceDefinitionsLoading,
  };
};

export default useThreatIntelligenceDefinition;
